import { memo } from 'react';

interface TableListProps {
  children: React.ReactNode;
}

const TableListBase = ({ children }: TableListProps) => {
  return <div className="flex flex-col">{children}</div>;
};

export const TableList = memo(TableListBase);
